import SwiperSlider from '../Sliders/SwiperSlider';
import ChoicesSelect from '@/js/components/Forms/Inputs/ChoicesSelect.js';

export default class SiteFilter {
  init() {
    this.filterForms = Array.from(document.querySelectorAll('.site-filter'));

    if (!this.filterForms.length) {
      return;
    }

    this.filterForms.forEach((filterForm) => {
      this.initSliders(filterForm);
      this.initChoices(filterForm);
      this.initAssociatedYearAndMonthFilter(filterForm);
    });
  }

  initSliders(filterForm) {
    const sliderElements = Array.from(filterForm.querySelectorAll('.swiper'));

    for (let sliderElement of sliderElements) {
      new SwiperSlider(sliderElement, {
        direction: 'horizontal',
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        slidesPerView: 'auto',
        freeMode: true,
        spaceBetween: 0,
        pagination: false,
        navigation: false,
        centerInsufficientSlides: false,
        on: {
          afterInit(swiper) {
            let currentSlideIndexOnLoad = [];

            swiper.slides.forEach((slide, index) => {
              if (
                slide.classList.contains('site-filter__swiper-slide--checked')
              ) {
                currentSlideIndexOnLoad.push(index);
              }
            });

            if (currentSlideIndexOnLoad.length) {
              swiper.slideTo(currentSlideIndexOnLoad[0]);
            }
          },
        },
      });
    }
  }

  initAssociatedYearAndMonthFilter(form) {
    const hasYearFilter = form.querySelector(
      'select option[data-associated-months]'
    );

    if (!hasYearFilter) {
      return;
    }

    const yearSelect = form.querySelector('select[name="years"]');
    const monthSelect = form.querySelector('select[name="months"]');

    if (!yearSelect || !monthSelect) {
      return;
    }

    yearSelect.addEventListener('change', () => {
      this.updateAssociatedMonthFilter(form, yearSelect, monthSelect);
    });

    this.updateAssociatedMonthFilter(form, yearSelect, monthSelect, false);
  }

  updateAssociatedMonthFilter(
    form,
    yearSelect,
    monthSelect,
    resetToplaceholderValue = true
  ) {
    const months = monthSelect.querySelectorAll('option');

    const selectedOption = yearSelect.options[yearSelect.selectedIndex];
    let associatedMonths = selectedOption.dataset.associatedMonths;

    if (!associatedMonths) {
      months.forEach((month) => {
        month.disabled = false;
      });

      return;
    }

    associatedMonths = JSON.parse(associatedMonths);

    months.forEach((month) => {
      if (month.value === '') {
        return;
      }

      if (associatedMonths.includes(month.value)) {
        month.disabled = false;
      } else {
        month.disabled = true;
      }
    });

    if (resetToplaceholderValue) {
      monthSelect.value = '';
    }
  }

  initChoices(form) {
    const multipleChoicesElements = Array.from(
      form.querySelectorAll('.site-filter__input--choices')
    );

    for (const multipleChoicesElement of multipleChoicesElements) {
      new ChoicesSelect(multipleChoicesElement, { multiple: true });
    }

    const simpleChoicesElements = Array.from(
      form.querySelectorAll('.site-filter__input--select')
    );

    for (const multipleChoicesElement of simpleChoicesElements) {
      new ChoicesSelect(multipleChoicesElement, { multiple: false });
    }
  }
}
